const TermHelperIcon = ({ icon }) => (
	<span className="p-inputgroup-addon">
		<i className={icon} />
	</span>
);

export default TermHelperIcon;
